document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("create_customer");
  const inputs = form?.querySelectorAll('input[type="email"], input[type="text"], input[type="tel"], input[type="password"]');
  const daySelect = document.getElementById("select-day");
  const monthSelect = document.getElementById("select-month");
  const yearSelect = document.getElementById("select-year");
  const dobError = document.querySelector("#RegisterForm-DOB")?.closest(".input-group").querySelector(".error-message");

  const passwordInput = document.getElementById("RegisterForm-password");
  const confirmPasswordInput = document.getElementById("RegisterForm-password-confirmation");
  const passwordError = confirmPasswordInput.closest(".field-warpper").querySelector(".error-message");

  function populateDOB() {
    // Days: 01–31 (01 selected by default)
    if (daySelect) {
      daySelect.innerHTML = "";
      for (let d = 1; d <= 31; d++) {
        const val = String(d).padStart(2, "0");
        daySelect.insertAdjacentHTML("beforeend", `<option value="${val}">${val}</option>`);
      }
    }

    // Months: Jan–Dec (Jan selected by default)
    if (monthSelect) {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      monthSelect.innerHTML = "";
      months.forEach((name, i) => {
        const val = String(i + 1).padStart(2, "0");
        monthSelect.insertAdjacentHTML("beforeend", `<option value="${val}">${name}</option>`);
      });
    }

    // Years: current year (selected) down to 1920
    if (yearSelect) {
      const currentYear = new Date().getFullYear();
      yearSelect.innerHTML = "";
      for (let y = currentYear; y >= 1920; y--) {
        yearSelect.insertAdjacentHTML("beforeend", `<option value="${y}">${y}</option>`);
      }
    }
  }

  populateDOB();

  function isValidEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  function validateForm() {
    let isValid = true;

    inputs.forEach(function (input) {
      if (input.type === "tel") {
        return; // Skip validation for phone input
      }

      const value = input.value.trim();
      const errorMessage = input.closest(".field-warpper").querySelector(".error-message");

      if (value === "") {
        isValid = false;
        errorMessage.classList.remove("hidden");
      } else {
        errorMessage.classList.add("hidden");
      }

      // Email validation
      if (input.type === "email") {
        const emailError = input.closest(".field-warpper").querySelector(".error-message");
        const invalidEmailError = input.closest(".field-warpper").querySelector(".error-message_invalidmail");

        if (value === "") {
          emailError.classList.remove("hidden");
          invalidEmailError.classList.add("hidden"); // Hide invalid email error
          isValid = false;
        } else if (!isValidEmail(value)) {
          invalidEmailError.classList.remove("hidden");
          emailError.classList.add("hidden"); // Hide empty field error
          isValid = false;
        } else {
          emailError.classList.add("hidden");
          invalidEmailError.classList.add("hidden"); // Hide both errors if valid
        }
      }
    });

    // Password validation
    if (confirmPasswordInput.value.trim() === "") {
      passwordError.textContent = "Please confirm your password.";
      passwordError.classList.remove("hidden");
      isValid = false;
    } else if (
      passwordInput.value.trim() !== confirmPasswordInput.value.trim()
    ) {
      passwordError.textContent = "Passwords do not match, please re-enter.";
      passwordError.classList.remove("hidden");
      isValid = false;
    } else {
      passwordError.classList.add("hidden");
    }

    return isValid;
  }

  function validateDOB() {
    let isValid = true;

    const year = yearSelect?.value ? parseInt(yearSelect.value, 10) : null;

    if (!year || isNaN(year)) {
      isValid = false;
      dobError.classList.remove("hidden");
    } else {
      const currentYear = new Date().getFullYear();
      const age = currentYear - year;

      if (age < 19) {
        isValid = false;
        dobError.classList.remove("hidden");
      } else {
        dobError.classList.add("hidden");
      }
    }

    return isValid;
  }

  function validateAll() {
    const formValid = validateForm();
    const dobValid = validateDOB();
    return formValid && dobValid;
  }

  // Validate on button click
  document.querySelectorAll(".register_account-validation").forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();

      if (validateAll()) {
        let prevButton = this.previousElementSibling;
        if (prevButton) {
          prevButton.click();
        }
      }
    });
  });

  // Validate Year when Day, Month, or Year is changed
  [daySelect, monthSelect, yearSelect].forEach((select) => {
    select?.addEventListener("change", validateDOB);
  });
});